import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { Bill } from '@mews-commander/data-access';
import { ActionLogItem, ApplicationState } from '@mews-commander/types';
import { Card, ModalBodyWrapper, ModalWrapper } from '@mews-commander/ui';
import { getSortedActionLogItemsByEntityOrOwnerId } from '@mews-commander/legacy-entities/src/ducks/actionLogItems';
import { getBill } from '@mews-commander/legacy-entities/src/ducks/bills';
import ModalHeader from '../../../../legacy/React/Components/Common/ModalHeader';
import { useCloseButton } from '../../../../core/windowManager/hooks';
import ActionLogItemList from '../ActionLogItemList';
import ActionLogName from '../ActionLogName';

interface OwnProps {
    billId: string;
}

interface StateProps {
    bill?: Bill;
    actionLogItems: ActionLogItem[];
}

type BillActionLogProps = OwnProps & StateProps;

const BillActionLogPage = ({ bill, actionLogItems }: BillActionLogProps) => {
    const closeButton = useCloseButton();

    return (
        <ModalWrapper>
            <ModalHeader primaryAction={closeButton} title={<ActionLogName title={bill?.name} />} />
            <ModalBodyWrapper padded>
                <Card>
                    <ActionLogItemList actionLogItems={actionLogItems} />
                </Card>
            </ModalBodyWrapper>
        </ModalWrapper>
    );
};

export default pipe(
    BillActionLogPage,
    connect<StateProps, {}, OwnProps, ApplicationState>((state, { billId }) => ({
        bill: getBill(state, { id: billId }),
        actionLogItems: getSortedActionLogItemsByEntityOrOwnerId(state, { entityId: billId }),
    }))
);
